import React from "react";
import style from "./ViewScore.module.css";

import DisplayPicture from "../../Components/DisplayPicture/DisplayPicture";

export function ScoreCard({ score, scoreType, handleScoreClick }) {
  const handleLocalScoreClick = () => {
    handleScoreClick(score);
  };

  return (
    <div
      className={`${style.titleContainer} pointerCursor mb-3`}
      onClick={handleLocalScoreClick}
    >
      <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <DisplayPicture className="profileImage" image={score.Image} />
          <div>
            <div className="h4 ml-3">{score && score.FirstName}</div>
            <div className="h6 ml-3">{score && score.LastName}</div>
          </div>
        </div>
        <div className="d-flex align-items-center">
          <div>
            {score.Comments}
            <i className="mdi mdi-comment-text ml-1 mr-2"></i>
          </div>
          <div>
            {score.Likes}
            <i className="mdi mdi-thumb-up ml-1 mr-2"></i>
          </div>
          <div className={`${style.highestScore} ml-2`}>
            {scoreType === 0
              ? score.HighestScore === "true"
                ? "Completed"
                : "Incomplete"
              : score.HighestScore}
          </div>
        </div>
      </div>
    </div>
  );
}
